import { render, staticRenderFns } from "./my-batch-add-vehicle-info-business-note-modal.vue?vue&type=template&id=3f3cd1c2"
import script from "./my-batch-add-vehicle-info-business-note-modal.vue?vue&type=script&lang=js"
export * from "./my-batch-add-vehicle-info-business-note-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports